import Vue from 'vue'
import userFormatter from "@/components/formatter/userFormatter";

Vue.filter('user', function (value) {
  return userFormatter(value);
})
